<template>
  <div class="top-nav">
    <div class="logo">
      <span>低代码平台</span>
    </div>
    <el-menu
      :default-active="activeTopMenu"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item
        v-for="menu in menus"
        :key="menu.uid"
        :index="menu.uid"
      >
        <i :class="menu.icon"></i>
        <span>{{ menu.name }}</span>
      </el-menu-item>
    </el-menu>
    <div class="right-menu">
      <el-dropdown @command="handleCommand" trigger="click">
        <div class="user-info">
          <el-avatar :size="32" :src="userAvatar" class="avatar">
            {{ userInfo?.username?.charAt(0) || 'U' }}
          </el-avatar>
          <span class="username">{{ userInfo?.username || '用户' }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="profile">
            <i class="el-icon-user"></i>
            个人资料
          </el-dropdown-item>
          <el-dropdown-item command="settings">
            <i class="el-icon-setting"></i>
            账户设置
          </el-dropdown-item>
          <el-dropdown-item divided command="logout">
            <i class="el-icon-switch-button"></i>
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import AuthService from '@/api/system/auth'

export default {
  props: {
    topMenus: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeTopMenu: ''
    }
  },
  computed: {
    menus() {
      var items = this.topMenus.filter(menu => menu.visible == 1);
      if(this.$store.state.app.activeTopMenu == null)
      {
        if(items.length > 0)
        {
          this.handleSelect(items[0].uid)
        }
      }
      return items;
    },
    userInfo() {
      return AuthService.getCurrentUser() || {}
    },
    userAvatar() {
      return this.userInfo.avatar || ''
    }
  },
  methods: {
    handleSelect(menuId) {
      this.$store.commit('app/SET_ACTIVE_TOP_MENU', { 
        menuId: menuId, 
        rootState: this.$store.state 
      })
    },
    
    handleCommand(command) {
      switch (command) {
        case 'profile':
          this.$router.push('/profile')
          break
        case 'settings':
          this.$router.push('/settings')
          break
        case 'logout':
          this.handleLogout()
          break
      }
    },
    
    async handleLogout() {
      try {
        await this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        await AuthService.logout()
        
      } catch (error) {
        if (error === 'cancel') {
          return
        }
        console.log('退出登录失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top-nav {
  display: flex;
  align-items: center;
  height: 70px;
  background: #001529;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  
  .logo {
    width: 200px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color:#fff;
  }
  
  .el-menu {
    flex: 1;
    border-bottom: none;
    background: transparent;
    
    .el-menu-item {
      color: rgba(255, 255, 255, 0.8);
      background: transparent;
      
      &:hover,
      &.is-active {
        color: #fff;
        background: rgba(255, 255, 255, 0.1);
        border-bottom: 2px solid #1890ff;
      }
    }
  }
  
  .right-menu {
    padding-right: 20px;
    
    .user-info {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      cursor: pointer;
      border-radius: 4px;
      transition: background-color 0.3s;
      
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
      
      .avatar {
        background: #1890ff;
        color: #fff;
        font-weight: bold;
        margin-right: 8px;
      }
      
      .username {
        color: #fff;
        font-size: 14px;
        margin-right: 8px;
      }
      
      .el-icon--right {
        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
}
</style>